import {z} from 'zod'
import {zx} from '../type'

export const comparisonTypeMd = {
  'base-rate': {
    label: 'Base Rate',
    desc: 'A relevant number that provides a helpful reference for forecasting',
    color: 'var(--mantine-color-blue-6)'
  },
  forecast: {
    label: 'Forecast',
    desc: 'A specific prediction for this question from a source',
    color: 'var(--mantine-color-orange-6)'
  }
} as const

export const zComparisonType = z.enum(['base-rate', 'forecast'])
export type ComparisonType = z.infer<typeof zComparisonType>

export const zComparison = z.object({
  title: z.string().describe('The title of the comparison'),
  url: z.string().optional().describe('The url of the comparison'),
  by: z.string(),
  description: zx.nullish.string,
  value: z.number(),
  color: zx.nullish.string,
  type: zComparisonType.optional(),
  faviconUrl: z.string().optional().describe('The URL of the favicon for the comparison source')
})
export type Comparison = z.infer<typeof zComparison>

export const comparisonColor = (type: ComparisonType) => comparisonTypeMd[type].color
